import React from "react";
import { useTranslation } from "react-i18next";

const NoteInput = ({ errors, register }) => {
   const { t: translator } = useTranslation();
   return (
      <div className="form-group">
         <label>{translator("InitialState-Note")}</label>
         <textarea
            name="note"
            ref={register({ maxLength: 250 })}
            className="form-control"
            rows={4}
            id="textArea"
         ></textarea>
         {errors.note && errors.note.type === "maxLength" && (
            <p className="text-danger">
               {translator("ValidationMsg-MaxLength250")}
            </p>
         )}
      </div>
   );
};

export default NoteInput;
